import { FunctionComponent, ReactNode } from "react";

import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { classNames } from "@/utils/classNames";

/**
 * Left-aligned system-event pill in the inbox thread (LinkedIn invite accepted,
 * calendar responses, …). Optionally shows a `→ avatar` badge for the connected
 * account the event resolved to. Tailwind-only and self-contained.
 */
export const ThreadSystemPill: FunctionComponent<{
	icon: ReactNode;
	label: string;
	connectedInitials?: string | null;
	connectedTitle?: string;
	timestamp?: ReactNode;
	className?: string;
}> = ({ icon, label, connectedInitials, connectedTitle, timestamp, className }) => {
	return (
		<div
			className={classNames(
				"self-start inline-flex items-center gap-2 bg-brand-white border border-border-light rounded-full px-3 py-1.5 text-sm font-semibold text-text-meta",
				className
			)}
			data-testid="thread-system-pill"
		>
			<span className="flex items-center justify-center shrink-0">{icon}</span>
			<span>{label}</span>
			{connectedInitials && (
				<span className="inline-flex items-center gap-1">
					<Icon className="w-3 h-3 text-text-disabled" icon={faArrowRight} />
					<span
						className="w-5 h-5 rounded-full bg-brand-light text-white text-[8.5px] font-bold flex items-center justify-center shrink-0"
						title={connectedTitle}
					>
						{connectedInitials}
					</span>
				</span>
			)}
			{timestamp && <span className="text-text-meta font-normal ml-1">{timestamp}</span>}
		</div>
	);
};
